import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { UserProfileExamsBadgeComponent } from './user-profile-exams-badge/user-profile-exams-badge.component';
import { UserProfileExamsCalloutComponent } from './user-profile-exams-callout/user-profile-exams-callout.component';
import { UserProfileExamsGridViewComponent } from './user-profile-exams-grid-view/user-profile-exams-grid-view.component';
import { UserProfileExamsRedesignComponent } from './user-profile-exams-redesign.component';

@NgModule({
  imports: [ComponentsModule, CommonModule, PipesModule, UiModule],
  declarations: [
    UserProfileExamsBadgeComponent,
    UserProfileExamsCalloutComponent,
    UserProfileExamsGridViewComponent,
    UserProfileExamsRedesignComponent,
  ],
  exports: [
    UserProfileExamsGridViewComponent,
    UserProfileExamsRedesignComponent,
  ],
})
export class UserProfileExamsRedesignModule {}
